import type { EnvironmentConfig } from './types';

export const parseConfig = (): EnvironmentConfig => {
  if (process.env.CONFIG) {
    return JSON.parse(process.env.CONFIG) as EnvironmentConfig;
  }
  if (process.env.NEXT_PUBLIC_CONFIG) {
    return JSON.parse(process.env.NEXT_PUBLIC_CONFIG) as EnvironmentConfig;
  }
  if (process.env.NODE_ENV === 'test') {
    // it's useful to be able to get the configuration in tests without
    // it being specified on the command line.
    // we can use `require` here because we know we're in a test environment,
    // and we want to synchronously load the configuration.
    // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
    return require('./environments').dangerouslyGetConfiguration('UNIT_TESTS');
  }
  throw new Error('CONFIG is not available');
};
